import { render, staticRenderFns } from "./weixinPayCode.vue?vue&type=template&id=23750bc0&scoped=true"
import script from "./weixinPayCode.vue?vue&type=script&lang=js"
export * from "./weixinPayCode.vue?vue&type=script&lang=js"
import style0 from "./weixinPayCode.vue?vue&type=style&index=0&id=23750bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23750bc0",
  null
  
)

export default component.exports